<template>
<!-- Loading -->
<div v-if="loading" class="result-card loading">
  <div class="flex justify-between">
    <div class="flex w-3/5">
      <SkeletonBox class="rounded" width="40px" height="40px" />
      <div class="flex-1">
        <SkeletonBox class="ml-16" width="100%" height="16px" />
        <div>
          <SkeletonBox class="ml-16 mt-8" width="40%" height="16px" />
        </div>
      </div>
    </div>
    <div class="flex justify-end w-1/5">
      <SkeletonBox :min-width="24" width="60%" height="16px" />
    </div>
  </div>
</div>
<!-- 有資料 -->
<!-- <div v-else class="result-card" :class="{'is-selectable': selectable, 'is-activated': $attrs.activated}" @click="$emit('click')">
  <div class="cover">
    <div class="inner" style="width: 40px; height: 40px;">
      <div class="flex justify-center items-center" >
        <img :src="type === 'hotel' ? require('@/assets/images/search/hotel.svg') : require('@/assets/images/search/location.svg')" alt="">
      </div>
    </div>
  </div>
  <div class="content">
    <div class="head">
      <div class="title"><v-clamp autoresize :max-lines="2">{{ title }}</v-clamp></div>
    </div>
    <div class="flex items-center">
      <div v-if="location" class="location">{{ location }}・</div>
      <div class="location">{{ typeText }}</div>
    </div>
  </div>
</div> -->
<div v-else class="result-card" :class="{'is-selectable': selectable, 'is-activated': $attrs.activated}" @click="$emit('click')">
  <div class="flex items-center" style="padding: 10px 16px">
    <div class="inner" style="min-width: 40px; width: 40px; height: 40px;">
      <div class="flex justify-center items-center" >
        <img v-if="type === 'hotel'" src="@/assets/images/search/hotel.svg" alt="">
        <img v-else-if="type === 'area'" src="@/assets/images/search/view.svg" alt="">
        <img v-else src="@/assets/images/search/location.svg" alt="">
      </div>
    </div>
    <div class="info ml-16 flex flex-col justify-between h-full">
      <div class="head">
        <div class="title"><v-clamp autoresize :max-lines="2">{{ title }}</v-clamp></div>
      </div>
      <div class="flex items-center">
        <div v-if="location" class="location">{{ location }}・</div>
        <div class="location">{{ typeText }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import VClamp from 'vue-clamp'
import _ from 'lodash'

import SkeletonBox from '@/components/skeletonBox.vue'

export default {
  name: 'resultCard',
  components: {
    SkeletonBox,
    VClamp
  },
  props: {
    // 讀取中
    loading: {
      type: Boolean,
      default: false
    },
    // 可選取
    selectable: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String
    },
    title: {
      type: String
      // default: function () {
      //   return []
      // }
    },
    type: {
      type: String
      // default: function () {
      //   return []
      // }
    },
    typeText: {
      type: String
      // default: function () {
      //   return []
      // }
    },
    location: {
      type: String
      // default: function () {
      //   return []
      // }
    }
  },
  data () {
    return {
    }
  },
  filters: {
    capitalize: function (string) {
      return _.capitalize(string)
    }
  },
  computed: {
  }
}
</script>

<style lang="sass" scoped>
.result-card
  @apply bg-white
  // @apply border-b border-grey-lighter
  @apply overflow-hidden
  &:first-child
    // @apply border-t-1 rounded-t-sm border-grey-lightest
  &:last-child
    @apply border-b-1 rounded-b-sm
  &.loading
    @apply bg-white border-l border-r border-grey-lightest justify-between px-16 py-8
  &:not(.loading)
    @apply flex justify-start
  &::not(::last-child)
    @apply border-t
  .cover
    @apply px-16 py-8
    .inner
      @apply rounded-lg overflow-hidden
      @apply flex items-center justify-center
      background: #e9edef
      div
        @apply w-full h-full
      i[class^="owl-"]
        @apply text-xl text-grey-darker
  .inner
    @apply rounded-lg overflow-hidden
    @apply flex items-center justify-center
    background: #e9edef
    div
      @apply w-full h-full
    i[class^="owl-"]
      @apply text-xl text-grey-darker
  .content
    @apply flex-auto flex flex-col flex-shrink
    @apply pb-8
    .head
      @apply flex justify-between flex-auto flex-shrink pt-8
      .title
        @apply text-sm font-bold leading-sm
        @apply mr-24
      .type
        @apply pr-16
        @apply flex-none flex items-center
        @apply text-xs
  .head
    @apply flex justify-between flex-auto flex-shrink
    .title
      @apply text-sm font-bold leading-sm
      @apply mr-24
    .type
      @apply pr-16
      @apply flex-none flex items-center
      @apply text-xs
  .location
    @apply text-xs font-medium
    color: #686E74
  &.is-selectable
    @apply cursor-pointer
    // &:hover
    //   @apply bg-blue-lightest
    &.is-activated
      @apply bg-grey-lightest
</style>
